























































































































































































































































































































































































































































import {Component, Vue} from 'vue-property-decorator';
import StoreDebug from '@/components/StoreDebug.vue';
import {Hotspot, HotspotOption} from "./services/GameLogic";
import Raven from "raven-js";
import FullscreenToggle from "./views/components/FullscreenToggle.vue";
import TutorialOverlay from "./views/TutorialOverlay.vue";

@Component({
    components: {TutorialOverlay, FullscreenToggle, StoreDebug},
    methods: {
        makelink(day: number, key: string): string {
            return '/day/' + day + '/' + key;
        },
        toggleDebugOverlay():void {
            this.$data.showDebugOverlay = !this.$data.showDebugOverlay;
        },
        handleKeyPress(e:KeyboardEvent):void {
            if( e.key === '~' || e.key === '`' ) {
                this.$data.showDebugOverlay = !this.$data.showDebugOverlay;
            }
        }
    },
    watch: {
        $route: function (val) {
            if (undefined !== val.params.day) {
                let newDayIndex = parseInt(this.$route.params.day);
                //if(newDayIndex!==this.$store.state.day) {
                    //console.log(['Nieuwe dag via router: ', val.params.day].join(''));
                    this.$store.state.day = newDayIndex;//parseInt(this.$route.params.day);
                    //this.$store.commit("startDay");
                //}
            }
            if( val.name != 'hotspot' ) {
                this.$store.state.currentHotspot = Hotspot.NONE;
            }
            this.$store.state.currentOption = HotspotOption.NONE;
            this.$store.commit('hideAnyTip');
        }
    },
    // created() {
    //     Raven.captureMessage('sentry test message');
    // },
    data: function() { return {
        showDebugOverlay: false
    }},
})

export default class App extends Vue {
}
